import { GenericServicesGetVideosFromYoutubePlaylist } from "@services/GenericServices";
import {debounce} from "lodash";

export default {
    data() {
        return {
            videos: [],
            playlistId: null,
            videoId: null,
        };
    },
    computed: {
        languageSpecificPlaylistId() {
            const envVar = `VUE_APP_TUTORIAL_PLAYLIST_${this.userLanguage.toUpperCase()}`;
            return process.env[envVar] || null;
        },
        userLanguage() {
            return this.$store.getters["auth/getState"].languageCode;
        }
    },
    watch: {
        userLanguage: {
            handler: function(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.getVideosFromPlaylist();
                }
            }
        }
    },
    methods: {
        getVideosFromPlaylist: debounce(function () {
            if (!this.languageSpecificPlaylistId) {
                this.videos = [];
                this.$store.commit("tutorials/setTutorialsState", this.videos);
                return;
            }

            this.videos = [];
            GenericServicesGetVideosFromYoutubePlaylist(this.languageSpecificPlaylistId)
                .then((response) => {
                    let items = response.data.result;
                    if (items.length > 0) {
                        for (let i = 0; i < items.length; i++) {
                            this.videos.push({
                                playlistId: items[i].snippet.playlistId,
                                videoId: items[i].snippet.resourceId.videoId,
                                title: items[i].snippet.title.replace(
                                    "Tutoriais DataDrive ",
                                    ""
                                ),
                            });
                        }
                    }
                })
                .catch(console.log)
                .finally(() => {
                    this.$store.commit(
                        "tutorials/setTutorialsState",
                        this.videos
                    );
                });
        }, 300),
        getFirstVideoFromPlaylist() {
            if (!this.playlistId && !this.languageSpecificPlaylistId) {
                return;
            }

            const playlistToUse = this.playlistId || this.languageSpecificPlaylistId;

            if (!playlistToUse) {
                return;
            }

            GenericServicesGetVideosFromYoutubePlaylist(playlistToUse)
                .then((response) => {
                    let items = response.data.result;
                    if (items.length > 0) {
                        this.videoId = items[0].snippet.resourceId.videoId;
                    }
                })
                .catch(console.log);
        },
        redirectToPlaylist(videoId, playlistId) {
            window.open(
                `https://www.youtube.com/watch?v=${videoId}&list=${playlistId}`,
                "_blank"
            );
        },
    },
};
